/**
 * 项目管理相关API
 */
import api from './api';

export interface Project {
  id: number;
  project_name: string;
  document_type: 'bid' | 'proposal';
  proposal_mode?: 'normal' | 'concise';
  project_overview?: string;
  tech_requirements?: string;
  business_requirements?: string;
  price_requirements?: string;
  file_content?: string;
  outline_data?: any;
  content_data?: any;
  status: 'draft' | 'generating' | 'completed' | 'archived';
  model_config_id?: number;
  generation_threads: number;
  expected_word_count?: number;
  current_word_count?: number;
  word_count_progress?: number;
  created_at: string;
  updated_at: string;
}

export interface ProjectCreateRequest {
  project_name: string;
  project_overview?: string;
  tech_requirements?: string;
  business_requirements?: string;
  price_requirements?: string;
  file_content?: string;
  model_config_id?: number;
  generation_threads?: number;
  expected_word_count?: number;
  proposal_mode?: 'normal' | 'concise';
}

export interface ProjectUpdateRequest {
  project_name?: string;
  project_overview?: string;
  tech_requirements?: string;
  business_requirements?: string;
  price_requirements?: string;
  outline_data?: any;
  content_data?: any;
  status?: 'draft' | 'generating' | 'completed' | 'archived';
  expected_word_count?: number;
}

export interface ProjectListResponse {
  success: boolean;
  projects: Project[];
  total: number;
  page: number;
  page_size: number;
}

export const projectApi = {
  // 获取项目列表
  getProjects: (params?: {
    page?: number;
    page_size?: number;
    status?: string;
    search?: string;
  }) => api.get<ProjectListResponse>('/api/projects', { params }),

  // 获取项目详情
  getProject: (id: number) =>
    api.get<Project>(`/api/projects/${id}`),

  // 创建项目
  createProject: (data: ProjectCreateRequest) =>
    api.post<Project>('/api/projects', data),

  // 更新项目
  updateProject: (id: number, data: ProjectUpdateRequest) =>
    api.put<Project>(`/api/projects/${id}`, data),

  // 删除项目
  deleteProject: (id: number) =>
    api.delete(`/api/projects/${id}`),

  // 复制项目
  duplicateProject: (id: number) =>
    api.post<Project>(`/api/projects/${id}/duplicate`),
};
